import React from 'react';
import {
  Topright,
  Heading,
  Box,
  FirstMember,
  TopMember,
  LeftTop,
  RightTop,
  BottomMember,
  Link,
  Title,
  Icon
} from './styles';
import SVGIcon from '../../../assets/images/svg/SVGIcon';
import { ICON_SIZE } from '../../../global/constants';

const MembersLoading: React.FC = () => {
  return (
    <Topright>
      <Heading>
        <Title>Member</Title>
        <Link>+ Add</Link>
      </Heading>
      <Box>
        <FirstMember>
          <TopMember>
            <LeftTop className='loading-animation'></LeftTop>
            <RightTop>
              <LeftTop className='right loading-animation'></LeftTop>
              <Icon>
                <SVGIcon
                  name='three-dots-horizontal-icon'
                  width={ICON_SIZE.LG}
                  height={ICON_SIZE.LG}
                  viewBox={`0 0 ${ICON_SIZE.LG} ${ICON_SIZE.LG}`}
                  fill='var(--background-muted)'
                />
              </Icon>
            </RightTop>
          </TopMember>
          <BottomMember className='loading-animation'></BottomMember>
        </FirstMember>
        <FirstMember>
          <TopMember>
            <LeftTop className='loading-animation'></LeftTop>
            <RightTop>
              <Icon>
                <SVGIcon
                  name='three-dots-horizontal-icon'
                  width={ICON_SIZE.LG}
                  height={ICON_SIZE.LG}
                  viewBox={`0 0 ${ICON_SIZE.LG} ${ICON_SIZE.LG}`}
                  fill='var(--background-muted)'
                />
              </Icon>
            </RightTop>
          </TopMember>
          <BottomMember className='loading-animation'></BottomMember>
        </FirstMember>
        <FirstMember>
          <TopMember>
            <LeftTop className='loading-animation'></LeftTop>
            <RightTop>
              <Icon>
                <SVGIcon
                  name='three-dots-horizontal-icon'
                  width={ICON_SIZE.LG}
                  height={ICON_SIZE.LG}
                  viewBox={`0 0 ${ICON_SIZE.LG} ${ICON_SIZE.LG}`}
                  fill='var(--background-muted)'
                />
              </Icon>
            </RightTop>
          </TopMember>
          <BottomMember className='loading-animation'></BottomMember>
        </FirstMember>
      </Box>
    </Topright>
  );
};

export default MembersLoading;
